import { render, staticRenderFns } from "./AuditTrailsData.vue?vue&type=template&id=2dcf2069"
import script from "./AuditTrailsData.vue?vue&type=script&lang=js"
export * from "./AuditTrailsData.vue?vue&type=script&lang=js"
import style0 from "./AuditTrailsData.vue?vue&type=style&index=0&id=2dcf2069&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports